import { createEffect, createEvent, createStore, sample } from 'effector';
import { api, unwrap, type Schemas } from '../../shared/api/client';

export const instrumentsRefreshed = createEvent();

export const loadInstrumentsFx = createEffect(() => unwrap(api.GET('/api/v1/instruments')));

export const createInstrumentFx = createEffect((body: Schemas['InstrumentIn']) =>
  unwrap(api.POST('/api/v1/instruments', { body })),
);

export const updateInstrumentFx = createEffect(
  ({ id, patch }: { id: number; patch: Schemas['InstrumentPatch'] }) =>
    unwrap(
      api.PATCH('/api/v1/instruments/{instrument_id}', {
        params: { path: { instrument_id: id } },
        body: patch,
      }),
    ),
);

export const deleteInstrumentFx = createEffect((id: number) =>
  unwrap(
    api.DELETE('/api/v1/instruments/{instrument_id}', { params: { path: { instrument_id: id } } }),
  ),
);

export const $instruments = createStore<Schemas['InstrumentOut'][]>([])
  .on(loadInstrumentsFx.doneData, (_, list) => list)
  .on(createInstrumentFx.doneData, (list, created) =>
    [...list, created].sort((a, b) => a.symbol.localeCompare(b.symbol)),
  )
  .on(updateInstrumentFx.doneData, (list, updated) =>
    list.map((i) => (i.id === updated.id ? updated : i)),
  )
  .on(deleteInstrumentFx.done, (list, { params }) => list.filter((i) => i.id !== params));

export const $instrumentsLoaded = createStore(false).on(loadInstrumentsFx.done, () => true);

export const $activeInstruments = $instruments.map((list) => list.filter((i) => i.active));

sample({
  clock: [
    instrumentsRefreshed,
    createInstrumentFx.done,
    updateInstrumentFx.done,
    deleteInstrumentFx.done,
  ],
  target: loadInstrumentsFx,
});
